import React, { useState, useEffect } from 'react';
import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase/firebase-config';
import { Save, Clock, Info } from 'lucide-react';
import toast, { Toaster } from 'react-hot-toast'; // Toaster mühürlendi
import './SettingsView.css';

const SettingsView = () => {
  const [settings, setSettings] = useState({
    workingStart: "09:00",
    workingEnd: "17:00",
    slotDuration: 20
  });

  // Ayarları Firebase'den çek
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const docRef = doc(db, "settings", "appointmentSettings");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setSettings(docSnap.data());
        }
      } catch (error) {
        console.error("Ayarlar çekilemedi:", error);
      }
    };
    fetchSettings();
  }, []);

  const handleSave = async () => {
    const loadingToast = toast.loading('Ayarlar güncelleniyor...');
    
    try {
      const docRef = doc(db, "settings", "appointmentSettings");
      
      // Kanka updateDoc yerine setDoc (merge: true) kullanıyoruz ki 
      // koleksiyon veya doküman yoksa sıfırdan oluştursun, hata vermesin.
      await setDoc(docRef, settings, { merge: true });
      
      toast.dismiss(loadingToast);
      toast.success("Ayarlar başarıyla kaydedildi! 🎉", {
        duration: 2000, // 2 saniye kuralı mühürlendi
        position: "top-center"
      });
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error("Hata oluştu: " + error.message, {
        duration: 3000
      });
    }
  };

  return (
    <div className="settings-container anim-in">
      {/* Pop-up'ların görünmesi için Toaster şart */}
      <Toaster position="top-center" reverseOrder={false} />
      
      <h2><Clock /> Randevu Saat Ayarları</h2>
      
      <div className="settings-card">
        <div className="settings-grid">
          <div className="input-group">
            <label>Mesai Başlangıç</label>
            <input 
              type="time" 
              value={settings.workingStart} 
              onChange={(e) => setSettings({...settings, workingStart: e.target.value})} 
            />
          </div>
          <div className="input-group">
            <label>Mesai Bitiş</label>
            <input 
              type="time" 
              value={settings.workingEnd} 
              onChange={(e) => setSettings({...settings, workingEnd: e.target.value})} 
            />
          </div>
        </div>

        <div className="input-group" style={{ marginBottom: '30px' }}>
          <label>Randevu Aralığı (Dakika)</label>
          <input 
            type="number" 
            placeholder="Örn: 20"
            value={settings.slotDuration} 
            onChange={(e) => setSettings({...settings, slotDuration: parseInt(e.target.value) || 0})} 
          />
        </div>

        <button onClick={handleSave} className="btn-save">
          <Save size={18}/> Ayarları Kaydet
        </button>

        <div className="settings-info">
          <Info size={16} />
          <p>
            Burada yaptığınız değişiklikler, randevu sayfasındaki saat dilimlerini 
            (slotları) otomatik olarak yeniden hesaplayacaktır.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SettingsView;